// Shared constants and content data for the PER landing page.

export const CHECKOUT_URL = 'https://ebookpoint.shop/cart/49981408542972:1'
export const SUPPORT_EMAIL = 'EbookDreamShop@gmail.com'
export const META_PIXEL_ID = '1252242806993118'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/hHVwhrgXAGJm8bJPfxf1rT/ChatGPT_Image_Jul_4,_2026,_08_40_27_PM.png'
export const BACKGROUND_IMAGE =
  'https://cdn.magicpatterns.com/patterns/generated-images/cccb5d4e-475e-4b5f-bfe5-44a74e1b8ce4.jpg'

export const PRICE_NOW = '27'
export const PRICE_BEFORE = '86'
export const SPOTS_LEFT = 371
export const SPOTS_TOTAL = 500

// Scroll to the purchase section.
export function goToCheckout(): void {
  const el = document.getElementById('comprar')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

// 14 modules of the PER pack (copy provided by client, not altered).
export interface ModuleItem {
  emoji: string
  title: string
  description: string
}

export const MODULES: ModuleItem[] = [
  {
    emoji: '⚓',
    title: 'Nomenclatura y Construcción del Buque',
    description:
      'Aprende las partes esenciales de la embarcación, su terminología y cómo está construida para que domines el lenguaje náutico desde el primer día.',
  },
  {
    emoji: '⚙️',
    title: 'Motores y Sistemas de a Bordo',
    description:
      'Comprende el funcionamiento del motor, los sistemas eléctricos y de agua, y el mantenimiento básico para navegar sin sustos.',
  },
  {
    emoji: '🛟',
    title: 'Seguridad en la Navegación',
    description:
      'Todo el material de seguridad obligatorio, prevención de riesgos y protocolos para proteger a tu tripulación en cualquier situación.',
  },
  {
    emoji: '🚦',
    title: 'Balizamiento',
    description:
      'Interpreta boyas, marcas laterales y cardinales del sistema IALA para saber siempre por dónde puedes navegar con seguridad.',
  },
  {
    emoji: '📕',
    title: 'Reglamento Internacional para Prevenir los Abordajes (RIPA)',
    description:
      'El corazón del examen. Domina las reglas de rumbo y gobierno para evitar colisiones y responder correctamente en el test.',
  },
  {
    emoji: '💡',
    title: 'Luces, Marcas y Señales',
    description:
      'Reconoce de un vistazo qué embarcación tienes delante de día o de noche gracias a sus luces, marcas y señales acústicas.',
  },
  {
    emoji: '🌦️',
    title: 'Meteorología Náutica',
    description:
      'Interpreta partes meteorológicos, la escala Beaufort y las nubes para anticiparte al tiempo y decidir cuándo salir a navegar.',
  },
  {
    emoji: '🗺️',
    title: 'Cartografía Náutica e Instrumentos',
    description:
      'Aprende a leer la carta náutica y a usar el compás, el GPS y demás instrumentos para situarte con precisión en el mar.',
  },
  {
    emoji: '🧭',
    title: 'Navegación Costera y Estimada',
    description:
      'Calcula rumbos, marcaciones y situación estimada paso a paso, con planillas prácticas para resolver los problemas del examen.',
  },
  {
    emoji: '📻',
    title: 'Radiocomunicaciones Marítimas',
    description:
      'Bono standalone. Uso de la radio VHF, canales de emergencia y protocolos de comunicación marítima incluido certificado SRC.',
  },
  {
    emoji: '🚤',
    title: 'Maniobras',
    description:
      'Atraque, desatraque, fondeo y maniobras de hombre al agua explicadas de forma sencilla para que ganes confianza al timón.',
  },
  {
    emoji: '🩹',
    title: 'Primeros Auxilios a Bordo',
    description:
      'Bono standalone. Actúa con calma ante mareos, heridas o emergencias médicas mientras estás en el mar.',
  },
  {
    emoji: '⚖️',
    title: 'Legislación y Responsabilidades del Patrón',
    description:
      'Bono standalone. Conoce tus obligaciones legales, documentación y responsabilidades como patrón de la embarcación.',
  },
  {
    emoji: '🎯',
    title: 'Preparación Final para el Examen',
    description:
      'Repaso general, estrategias para el test y simulacros para que llegues al examen con seguridad y lo apruebes a la primera.',
  },
]

// 7 bonuses included with the pack.
export interface BonusItem {
  emoji: string
  title: string
  description: string
  previewImage: string
}

export const BONUSES: BonusItem[] = [
  {
    emoji: '📝',
    title: 'Banco de Preguntas Comentadas (65)',
    description:
      '65 preguntas tipo examen con su explicación comentada para que entiendas el porqué de cada respuesta.',
    previewImage:
      'https://cdn.magicpatterns.com/uploads/vAYS11r9tWd2pC8hwXBwWY/Bono_1_.png',
  },
  {
    emoji: '🖥️',
    title: 'Simulacro de Examen Interactivo (autocorrección)',
    description:
      'Practica en condiciones reales con corrección automática para medir tu progreso.',
    previewImage:
      'https://cdn.magicpatterns.com/uploads/7r79ov7RcAZ1gciy1LNRoR/Bono_2.png',
  },
  {
    emoji: '🧭',
    title: 'Planilla — Situación y Rumbo Estimado',
    description:
      'Plantilla lista para resolver los problemas de situación y rumbo estimado sin bloquearte.',
    previewImage:
      'https://cdn.magicpatterns.com/uploads/6uENELP8BttWrVEYCZ7j5c/Bono_3.png',
  },
  {
    emoji: '🚦',
    title: 'Chuleta de Balizamiento e IALA',
    description:
      'Resumen visual del balizamiento y el sistema IALA para repasar en segundos.',
    previewImage:
      'https://cdn.magicpatterns.com/uploads/pjvn1Us8956bBZbfzeSsvB/Bono_4_.png',
  },
  {
    emoji: '💡',
    title: 'Chuleta de Luces y Marcas',
    description:
      'Identifica al instante luces y marcas de cualquier embarcación con esta chuleta.',
    previewImage:
      'https://cdn.magicpatterns.com/uploads/7bNJNFHjc2AY6qJo4pJ4Vz/Bono_5.png',
  },
  {
    emoji: '🌬️',
    title: 'Planilla — Escala Beaufort y Decisiones',
    description:
      'Relaciona la escala Beaufort con decisiones prácticas de navegación.',
    previewImage:
      'https://cdn.magicpatterns.com/uploads/h73shWZGqNYCvwob2AzDvv/Bono_6_.png',
  },
  {
    emoji: '🔢',
    title: 'Formulario — Fórmulas de Navegación',
    description:
      'Todas las fórmulas de navegación que necesitas, reunidas en un solo formulario.',
    previewImage:
      'https://cdn.magicpatterns.com/uploads/uBLxZpSrPycRGG9JqC48tH/Bono_7.png',
  },
]

// Common problems / fears of PER candidates in Spain.
export const PROBLEMS: string[] = [
  'Te bloqueas con el RIPA y las reglas de rumbo, y acabas eligiendo la respuesta equivocada por los nervios.',
  'Las academias presenciales tienen horarios rígidos que no encajan con tu trabajo ni con tu vida.',
  'Pagas cientos de euros en cursos y sigues sin sentirte preparado el día del examen.',
  'Te agobia la cartografía y los problemas de situación y rumbo estimado porque nadie te los explica claro.',
  'Llegas al examen con miedo a suspender y a tener que pagar de nuevo la matrícula y volver a empezar.',
]

// 5-star reviews (Spanish, matching the avatar).
export interface Review {
  name: string
  location: string
  text: string
}

export const REVIEWS: Review[] = [
  {
    name: 'Javier M.',
    location: 'Valencia',
    text: 'Aprobé a la primera estudiando desde el móvil por las noches. El banco de preguntas comentadas fue clave, entendía el porqué de cada respuesta.',
  },
  {
    name: 'Marta R.',
    location: 'Alicante',
    text: 'El RIPA me daba pánico y con las chuletas y el simulacro lo saqué sin problema. Muchísimo mejor que la academia a la que iba antes.',
  },
  {
    name: 'Sergio L.',
    location: 'A Coruña',
    text: 'Empecé a estudiar 5 minutos después de comprarlo. Todo en PDF, ordenado y sin rellenos. Merece la pena cada euro.',
  },
  {
    name: 'Cristina P.',
    location: 'Málaga',
    text: 'Los bonos de navegación estimada y meteorología me salvaron. Llegué al examen tranquila y aprobé con nota.',
  },
]

// Short testimonials matching the product avatar (Spanish adults, 25-55).
export interface Testimonial {
  name: string
  age: number
  city: string
  text: string
}

export const TESTIMONIALS: Testimonial[] = [
  {
    name: 'Andrés Gómez',
    age: 38,
    city: 'Barcelona',
    text: 'Llevaba meses posponiendo el PER por los horarios. Con este pack estudié a mi ritmo y aprobé en tres semanas.',
  },
  {
    name: 'Lucía Fernández',
    age: 31,
    city: 'Palma de Mallorca',
    text: 'Por fin algo claro y directo. Las planillas de rumbo estimado valen su peso en oro.',
  },
  {
    name: 'Roberto Díaz',
    age: 45,
    city: 'Bilbao',
    text: 'Me ahorré una fortuna en academia. Todo lo que necesitaba estaba aquí y bien explicado.',
  },
  {
    name: 'Nuria Sánchez',
    age: 29,
    city: 'Sevilla',
    text: 'El simulacro interactivo me quitó los nervios del examen. Llegué sabiendo exactamente qué esperar.',
  },
  {
    name: 'Carlos Ruiz',
    age: 52,
    city: 'Cádiz',
    text: 'A mi edad pensaba que el estudio online no era para mí. Me equivocaba: sencillo y al grano. Aprobado.',
  },
]

// Objections and answers.
export interface Objection {
  question: string
  answer: string
}

export const OBJECTIONS: Objection[] = [
  {
    question: '¿Sirve aunque no tenga ni idea de navegación?',
    answer:
      'Sí. Empezamos desde cero con la nomenclatura del buque y avanzamos paso a paso hasta la preparación final del examen. No necesitas experiencia previa.',
  },
  {
    question: '¿Está actualizado al examen actual del PER?',
    answer:
      'Totalmente. El contenido cubre el temario oficial vigente del PER, incluido el RIPA, balizamiento, cartografía y radiocomunicaciones.',
  },
  {
    question: '¿En qué formato lo recibo?',
    answer:
      'Todo es 100% PDF descargable, más el simulacro interactivo. Lo tienes en tu correo de forma inmediata tras la compra.',
  },
  {
    question: '¿Puedo estudiar desde el móvil?',
    answer:
      'Claro. Está pensado para que estudies desde el móvil, la tablet o el ordenador, cuando y donde quieras, sin horarios ni academias.',
  },
  {
    question: '¿Y si tengo dudas después de comprar?',
    answer:
      'Escríbenos a nuestro correo de soporte y te ayudamos. Estamos para que apruebes a la primera.',
  },
]

// Comparison table rows.
export const COMPARISON: { without: string; with: string }[] = [
  {
    without: 'Dependes de horarios de academia',
    with: 'Estudias cuando quieras, a tu ritmo',
  },
  { without: 'Gastas cientos de euros', with: 'Un único pago de solo 27€' },
  {
    without: 'Material disperso y confuso',
    with: '14 módulos ordenados paso a paso',
  },
  {
    without: 'Miedo al RIPA y la cartografía',
    with: 'Chuletas y planillas que lo simplifican',
  },
  {
    without: 'Llegas al examen con nervios',
    with: 'Simulacro y repaso final para ir seguro',
  },
  {
    without: 'Riesgo de suspender y volver a pagar',
    with: 'Preparación para aprobar a la primera',
  },
]

// Purchase pop-up data.
export const POPUP_NAMES: string[] = [
  'Javier',
  'María',
  'Carlos',
  'Laura',
  'David',
  'Ana',
  'Sergio',
  'Cristina',
  'Miguel',
  'Elena',
  'Pablo',
  'Marta',
  'Antonio',
  'Lucía',
  'Alberto',
  'Sara',
  'Rubén',
  'Paula',
  'Fernando',
  'Nuria',
]

export const POPUP_CITIES: string[] = [
  'Madrid',
  'Barcelona',
  'Valencia',
  'Sevilla',
  'Bilbao',
  'Málaga',
  'Alicante',
  'A Coruña',
  'Palma de Mallorca',
  'Vigo',
  'Cádiz',
  'Santander',
  'San Sebastián',
  'Gijón',
  'Cartagena',
  'Tarragona',
  'Almería',
  'Las Palmas',
]
